import React, { Component } from 'react'
import { Grid, Segment, Header } from 'semantic-ui-react'
import { connect } from 'react-redux'

import RequestList from './components/RequestList'
import RequestActions from '../../reducers/merchantCloseRequestReducer'

import Loading from '../../components/common/loading'

class MerchantCloseRequests extends Component {
  componentDidMount() {
    const { syncPendingRequests } = this.props

    syncPendingRequests()
  }

  componentWillUnmount() {
    const { unSyncPendingRequests } = this.props

    unSyncPendingRequests()
  }

  render() {
    const { loading, requests, currentUsername} = this.props

    return (
      <div>
        {loading ? <Loading /> : null}
        <Grid>
          <Grid.Column width="16">
            <Segment color="black">
              <Header size="large" style={{ display: 'inline-block', marginLeft: 15, marginTop: 10 }}>
                Merchant Close Requests
              </Header>

              <RequestList
                key="pending"
                handler={currentUsername}
                loading={loading}
                requests={requests}
              />
            </Segment>
          </Grid.Column>
        </Grid>
      </div>
    )
  }
}

const mapState = ({ merchantCloseRequests, auth }) => ({
  requests: merchantCloseRequests.data,
  loading: merchantCloseRequests.loading,
  currentUsername: auth.data.username,
})

const mapDispatch = {
  syncPendingRequests: RequestActions.syncPendingRequests,
  unSyncPendingRequests: RequestActions.unSyncPendingRequests,
}

export default connect(
  mapState,
  mapDispatch
)(MerchantCloseRequests)



// WEBPACK FOOTER //
// ./src/containers/merchantCloseRequests/index.js